import type { SxStyle } from '@aibees/shared/theme';

export const dialogContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
};

export const dialogPaper: SxStyle = {
  overflowX: 'hidden',
};

export const descriptionInput: SxStyle = {
  width: '100%',
  boxSizing: 'border-box',
};
